<template>
	<div class="token-select-list" @click="close">
		<div class="container-fluid container-lg">
			<div class="row">
				<div class="mx-auto col-12 col-sm-10 col-md-9 col-lg-8 col-xl-6">
					<div
						class="card animate__animated animate__fadeIn"
						@click="(e) => e.stopPropagation()"
					>
						<div class="card-header">
							<div class="row">
								<div class="col-auto" @click="close">
									<i class="fa fa-arrow-left"></i>
								</div>
								<div class="col">
									<h3>Select Token</h3>
								</div>
								<div class="col-auto">
									<div class="toggle-wrapper noselect small">
										<input type="checkbox" id="toggle" class="toggle-checkbox" @change="() => {listToggle = !listToggle; $refs.search.focus()}">
										<label for="toggle" class="toggle-container noselect">
											<div class="toggle-option noselect">MY TOKENS</div>
											<div class="toggle-option noselect">TOP TOKENS</div>
											<div class="toggle-slider noselect"></div>
										</label>
									</div>
								</div>
								<div class="mt-2 col-12 field-group">
									<input
										ref="search"
										v-model="sVal"
										@input="onSearch"
										type="text"
										class="input"
										placeholder="Search or paste address"
									/>
								</div>
							</div>
						</div>
						<div class="px-1 card-body pe-0">
							<div class="scroll-list scrollbar">
								<div
									class="py-5 text-center"
									v-if="tokenList.length === 0 && sVal.length > 3"
								>
									<p><i>No tokens found!</i></p>

									<div v-if="sVal.length >= 42">
										<button
											@click="addCustomToken"
											class="btn btn-outline-primary"
										>
											Add Token
										</button>
									</div>
								</div>
								<div class="col-12" v-else>
									<table class="table text-start">
										<tbody :key="sVal">
										<tr
											v-if="
													(sVal.length < 3 ||
													sVal.indexOf('So1') > -1 ||
													sVal.toLowerCase().indexOf('sol') > -1) && 
													exceptTokenAddress !== SOL_MINT
												"
											:key="`x-So11111111111111111111111111111111111111112`"
											@click="(e) => select(e, SOL_TOKEN)"
										>
											<td class="align-middle position-relative ps-1">
												<TokenImage
													:no-favorites="true"
													:verified="true"
													:link="false"
													:show-name="true"
													:mint="SOL_MINT"
												>
													<template v-slot:symbols>
														<AccountAddress class="ms-1" :names="false" :address="SOL_MINT" :icon-only="true"></AccountAddress>
													</template>
												</TokenImage>
											</td>
											<td class="text-end">
												<p class="mb-0">
													<TokenPrice
														:maxDigits="2"
														:token="SOL_MINT"
													></TokenPrice>
												</p>
											</td>
											<td class="text-end">
												<p class="mb-0 small">
													<TokenPrice
														class="fw-bold"
														:maxDigits="2"
														:token="SOL_MINT"
														:amount="
																convertToHumanNumber(cacheStore.getUIAmountSOL)
															"
													></TokenPrice>
												</p>
												<p class="mb-0 small grey">
													{{
														convertToHumanNumber(cacheStore.getUIAmountSOL)
													}}
												</p>
											</td>
										</tr>

										<tr
											v-for="token in tokenList"
											:key="`${token.address}`"
											@click="(e) => select(e, token)"
										>
											<td class="align-middle position-relative ps-1">
												<TokenImage
													:verified="token.verified"
													:link="false"
													:show-name="true"
													:mint="token.address"
												>
													<template v-slot:symbols>
														<AccountAddress :names="false" :address="token.address" :icon-only="true"></AccountAddress>
														<RiskScore :score="token.rugcheckScore" :mint="token.address.toString()"></RiskScore>
													</template>
												</TokenImage>
											</td>
											<td class="text-end">
												<p class="mb-0">
													<TokenPrice
														:is-scientific-notation="true"
														:max-digits="4"
														:token="token.address"
													></TokenPrice>
												</p>
												<p class="mb-0 small grey" title="Trade Volume">
													<i class="bi bi-bar-chart grey"></i> ${{
														token?.volume
															? convertVolumeNumber(
																token?.volume?.toFixed(0)
															)
															: "-"
													}}
												</p>
											</td>
											<td class="text-end">
												<p class="mb-0 small">
													<TokenPrice
														v-if="token.uiAmount > 0"
														class="fw-bold"
														:is-scientific-notation="true"
														:max-digits="2"
														:token="token.address"
														:amount="
																cacheStore.getTokenBalance(token.address)
															"
													></TokenPrice>
													<span v-else class="token-price fw-bold">$0.00</span>
												</p>
												<p class="mb-0 small grey">
													{{
														convertToHumanNumber(
															cacheStore.getTokenBalance(token.address)
														)
													}}
												</p>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {web3} from "@project-serum/anchor";
import {TOKEN_2022_PROGRAM_ID} from "@solana/spl-token";
import {PROGRAM_ID} from "@metaplex-foundation/mpl-token-metadata";
import TokenImage from "@/components/common/TokenImage.vue";
import TokenPrice from "@/components/common/TokenPrice.vue";
import {useCacheStore} from "@/pinia/cacheStore";
import {SOL_MINT, SOL_TOKEN, convertToHumanNumber, removeTrailingZeros} from "@/shared";
import {mapStores} from "pinia";
import AccountAddress from "@/components/common/AccountAddress.vue";
import RiskScore from "@/components/common/RiskScore.vue";
import {fetchTopTokens} from "@/api/endpoints/stats";

export default {
	name: "TokenSelectList",
	components: {RiskScore, AccountAddress, TokenPrice, TokenImage},
	props: {
		tokenSelected: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			listToggle: false,
			searchTimeout: null,
			sVal: "",
			limit: 25,
			searchTokens: [],
			userTokens: [],
			topTokens: [],
			SOL_MINT: SOL_MINT,
			SOL_TOKEN: {...SOL_TOKEN},
			removeListener: null,
		};
	},
	computed: {
		...mapStores(useCacheStore),
		exceptTokenAddress: function () {
			if(this.tokenSelected?.address?.toString()) {
				if(this.$store.state.swap.tokenA?.address?.toString() === this.tokenSelected?.address?.toString()) {
					return this.$store.state.swap.tokenB?.address?.toString();
				} else {
					return this.$store.state.swap.tokenA?.address?.toString();
				}
			}

			return "";
		},
		tokenList: function () {
			let filteredTokens = this.tokens;

			// Filter out the opposite token from the store
			if (this.exceptTokenAddress) {
				filteredTokens = filteredTokens.filter(token => token?.address?.toString() !== this.exceptTokenAddress);
			}

			if (this.sVal.length < 2)
				return filteredTokens
					.slice(0, this.limit)
					.filter((t) => t.address !== SOL_MINT);

			let count = 0;
			let toks = [];
			for (let i = 0; i < this.userTokens.length; i++) {
				if (count > this.limit) continue;
				const t = this.userTokens[i];
				
				// Skip excluded token
				if (t.address?.toString() === this.exceptTokenAddress) continue;
				
				const sL = this.sVal.toLowerCase();
				if (
					t.name?.toLowerCase().indexOf(sL) > -1 ||
					t.symbol?.toLowerCase().indexOf(sL) > -1 ||
					t.address?.toLowerCase().indexOf(sL) > -1
				) {
					toks.push(t);
					count++;
				}
			}

			if (count < this.limit) {
				const keys = Object.keys(this.searchTokens);
				for (let i = 0; i < this.limit - count; i++) {
					if (i > keys.length - 1) break;
					
					// Skip excluded token
					if (this.searchTokens[keys[i]]?.address?.toString() === this.exceptTokenAddress) continue;
					
					toks.push(this.searchTokens[keys[i]]);
				}

				const dups = {};
				toks = toks.filter((t) => {
					const exists = dups[t.address];
					dups[t.address] = true;
					return !exists;
				});
			}

			return toks;
		},
		tokens: function () {
			if (this.searchTokens.length > 0) {
				return this.searchTokens;
			}

			if (this.listToggle) {
				return this.topTokens
			}

			return this.userTokens;
		},
		tokenMap: function () {
			return this.$store.state.cache.tokenMap;
		},
	},
	methods: {
		convertVolumeNumber: function (num) {
			if (num < 1000) return (num / 1).toFixed(1).toString();
			if (num < 1000000) return (num / 1000).toFixed(0) + "k";
			if (num < 1000000000) return (num / 1000000).toFixed(0) + "m";
			if (num < 1000000000000) return (num / 1000000000).toFixed(0) + "b";
			return (num / 1000000000000).toFixed(0) + "t";
		},
		convertToHumanNumber: function(num) {
			return convertToHumanNumber(num);
		},
		onSearch: function () {
			this.debounce(() => {
				if (this.sVal.length >= 3) {
					this.doSearch();
				} else {
					this.searchTokens = [];
				}
			}, 400);
		},
		debounce: function (func, wait) {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => func(), wait);
		},

		close: function (e) {
			if (e)
				e.preventDefault();

			this.$emit("close");
		},
		select: async function (e, token) {
			e.preventDefault();
			if (!token.amount) token.amount = 0;
			
			// Check if the token has a symbol, if not try to fetch it
			if (!token.symbol && token.address !== SOL_MINT) {
				try {
					const mint = new web3.PublicKey(token.address);
					const info = await this.$store.state.solana.tokenClient.getToken(mint);
					
					if (info && info.value) {
						const metaProg = info.value.owner.equals(TOKEN_2022_PROGRAM_ID) ? null : PROGRAM_ID;
						const metaInfo = await this.$store.state.solana.tokenClient.getTokenMetadata(mint, metaProg).catch(() => {});
						
						if (metaInfo?.data?.symbol) {
							token.symbol = metaInfo.data.symbol.trim().split(/\r|\r\n|\n/)[0];
						} else {
							token.symbol = "UNKNOWN"; // Default symbol if none is found
						}
						
						// Also update other token information if available
						if (metaInfo?.data?.name) {
							token.name = metaInfo.data.name.trim().split(/\r|\r\n|\n/)[0];
						}
						if (metaInfo?.data?.uri) {
							token.uri = metaInfo.data.uri.trim().split(/\r|\r\n|\n/)[0];
						}
					}
				} catch (error) {
					console.error("Error fetching token symbol:", error);
					token.symbol = "UNKNOWN"; // Fallback in case of error
				}
			}
			
			this.$emit("select", token);
		},
		addCustomToken: async function () {
			const mint = new web3.PublicKey(this.search);
			console.log("Mint", mint.toString());
			const info = await this.$store.state.solana.tokenClient.getToken(mint);
			if (!info || !info.value) {
				this.$toastr.e("Invalid token mint");
				return;
			}
			console.log("addCustomToken", info);

			const metaProg = info.value.owner.equals(TOKEN_2022_PROGRAM_ID)
				? null
				: PROGRAM_ID;
			const metaInfo = await this.$store.state.solana.tokenClient
				.getTokenMetadata(mint, metaProg)
				.catch(() => {
				});

			this.$store.commit("cache/add_token", {
				address: mint.toString(),
				amount: 0,
				decimals: info.value.data.parsed.info.decimals,
				image: "",
				metadata: "",
				name:
					metaInfo?.data?.name?.trim().split(/\r|\r\n|\n/)[0] || "Custom Token",
				programID: info.value.owner.toString(),
				supply: info.value.data.parsed.info.supply,
				symbol:
					metaInfo?.data?.symbol?.trim().split(/\r|\r\n|\n/)[0] || "CUSTOM",
				uri: metaInfo?.data?.uri?.trim().split(/\r|\r\n|\n/)[0],
				verified: false,
			});

			this.$store.state.solana.tokenClient
				.getUserTokenAccount(
					mint,
					new web3.PublicKey(this.$store.state.wallet.address),
					info.value.owner
				)
				.then((userInfo) => {
					console.log("userInfo", userInfo);
					if (userInfo.value)
						this.$store.commit("cache/add_user_token", {
							account: userInfo.value,
							pubkey: mint,
						});
				});
		},

		doSearch: function () {
			console.log("Searching", this.sVal);
			this.searchTokens = [];
			this.$store.state.solana.fluxClient.searchToken(this.sVal).then((r) => {
				this.searchTokens = r;
			});
		},

		loadTopTokens: async function () {
			try {
				const topTokenData = await fetchTopTokens({limit: 20});

				// Check if we have valid data
				if (!topTokenData || !Array.isArray(topTokenData) || topTokenData.length === 0) {
					this.topTokens = [];
					return;
				}

				// Extract mint addresses for batch price fetching
				const mintAddresses = topTokenData.map(token => token.mint).filter(Boolean);

				if (mintAddresses.length === 0) {
					this.topTokens = [];
					return;
				}

				// Fetch prices in batch
				const prices = await this.$store.state.solana.tokenClient.getTokenPrices(mintAddresses);

				// Map the response to the expected format
				this.topTokens = topTokenData
					.map(token => {
						if (!token || !token.mint || !token.stats) {
							return null;
						}

						// Calculate total volume from buy and sell volumes
						const volume = (token.stats.buyVolume || 0) + (token.stats.sellVolume || 0);

						// Get price from the batch response
						const price = prices[token.mint]?.price || 0;

						// Cache the price for use elsewhere
						this.$store.commit("cache/set_token_price", {
							mint: token.mint,
							price: price
						});

						return {
							address: token.mint,
							rugcheckScore: token.rugCheckScore || 0,
							volume: volume,
							price: price,
						};
					})
					.filter(Boolean); // Remove any null entries
			} catch (error) {
				console.error("Error loading top tokens:", error);
				this.topTokens = [];
			}
		},

		loadUserTokens: async function () {
			const mints = [];

			const userTokens = Object.values(this.cacheStore.userTokenAccounts)
				.filter((r) => {
					if (!r.primitive) return false;

					return (
						r.primitive.account.data.parsed.info.tokenAmount.amount > 1 &&
						r.primitive.account.data.parsed.info.tokenAmount.decimals > 1
					);
				})
				.map((r) => {
					if (!this.$store.state.cache.tokenPrices[r.primitive.account.data.parsed.info.mint])
						mints.push(r.primitive.account.data.parsed.info.mint);

					return Object.assign(
						{
							address: r.primitive.account.data.parsed.info.mint,
							programID: r.primitive.account.owner?.toString(),
							decimals: r.primitive.account.data.parsed.info.tokenAmount.decimals,
							uiAmount: r.primitive.account.data.parsed.info.tokenAmount.uiAmount,
						},
						r.primitive.account.data.parsed.info,
						this.$store.state.cache.tokenMap[r.primitive.account.data.parsed.info.mint]
					);
				});

			const prices = await this.$store.state.solana.tokenClient.getTokenPrices(
				mints
			);
			for (const mint in prices) {
				this.$store.commit("cache/set_token_price", {
					mint: mint,
					price: prices[mint] || 0,
				});
			}

			this.userTokens = userTokens
				.filter((f) => {
					f.price = this.$store.state.cache.tokenPrices[f?.address]?.price || 0;
					// Don't filter out tokens with zero price, just assign the price
					return true; 
				})
				.sort((a, b) => {
					a.totalPrice = a.price * a.uiAmount;
					b.totalPrice = b.price * b.uiAmount;
					return b.totalPrice - a.totalPrice;
				});
		},
		setupEscapeKeyHandler: function (callback) {
			function handler(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					callback();
					document.removeEventListener('keydown', handler); // Clean up
				}
			}

			document.addEventListener('keydown', handler);

			// Return a function to manually remove the listener if needed
			return () => document.removeEventListener('keydown', handler);
		}

	},
	beforeMount() {
		this.loadTopTokens();
		this.loadUserTokens();

		this.removeListener = this.setupEscapeKeyHandler(() => {
			console.log('Escape pressed, closing modal');
			this.close()
		});
	},
	mounted() {
		// Dont auto focus on mobile as it brings up keyboard
		if (window.innerWidth > 780)
			this.$refs.search.focus();
	},
	beforeDestroy() {
		if (this.removeListener)
			this.removeListener()
	}
};
</script>

<style scoped>
.token-select-list {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	z-index: 10;
	background: transparent;

	animation-name: darken;
	animation-duration: 1s;
	animation-fill-mode: forwards;
}

.scroll-list {
	overflow-y: scroll;
	height: 70vh;
	transition: all 0.3s ease-out;
}

tr:hover {
	cursor: pointer;
	background: var(--bs-dark);
	border-radius: 6px;
}

sup {
	font-size: 0.5rem;
}

.toggle-wrapper {
	display: inline-block;
	position: relative;
}

.toggle-checkbox {
	display: none;
}

.toggle-container {
	display: flex;
	width: 240px;
	height: 28px;
	border: 1px solid rgb(var(--borderSecondary));
	border-radius: var(--rounded);
	position: relative;
	cursor: pointer;
	overflow: hidden;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
}

.toggle-option {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
	transition: color 0.3s ease, background-color 0.3s ease;
	position: relative;
	overflow: hidden;
}

.toggle-slider {
	position: absolute;
	top: 2px;
	left: 2px;
	width: calc(50% - 2px);
	height: calc(100% - 4px);
	background-color: rgb(var(--borderPrimary));
	border-radius: 3px;
	transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* Default shine animation (always present) */
.toggle-container::before {
	content: '';
	position: absolute;
	top: 0;
	left: -100%;
	width: 50%;
	height: 100%;
	background: linear-gradient(
		to right,
		rgba(255, 255, 255, 0) 0%,
		rgba(255, 255, 255, 0.3) 50%,
		rgba(255, 255, 255, 0) 100%
	);
	z-index: 2;
	animation: shine;
	animation-duration: 4s;
	animation-delay: 8s;
	animation-iteration-count: infinite;
}

@keyframes shine {
	0%, 20% {
		left: -100%;
	}
	70%, 100% {
		left: 200%;
	}
}

/* Simple hover effect */
.toggle-checkbox:not(:checked) + .toggle-container .toggle-option:last-child:hover {
	background-color: rgba(var(--borderPrimary), 0.1);
}

.toggle-checkbox:checked + .toggle-container .toggle-option:first-child:hover {
	background-color: rgba(var(--borderPrimary), 0.1);
}

.toggle-checkbox:checked + .toggle-container .toggle-slider {
	transform: translateX(100%);
}

.toggle-checkbox:checked + .toggle-container .toggle-option:last-child {
	color: white;
}

.toggle-checkbox:not(:checked) + .toggle-container .toggle-option:first-child {
	color: white;
}
</style>